export type ColorSchemeCategory = 'Basic' | 'Advanced' | 'Expert';

export interface ColorScheme {
  id: number;
  name: string;
  category: string;
  colors: string[];
}

export type ColorSchemeMap = {
  [id: string]: ColorScheme
}

export const colorSchemeMap: ColorSchemeMap = {
  0: {
    id: 0,
    name: 'Coolwarm',
    category: 'Basic',
    colors: ["#3288bd", "#abdd95", "#f2eb92", "#fda366", "#d63f4f"]
  },
  1: {
    id: 1,
    name: "Spectrum",
    category: 'Basic',
    colors: ["#fd00ff", "#4b0082", "#0000ff", "#00ff00", "#ffff00", "#ffa500", "#ff0000"],
  },
  2: {
    id: 2,
    name: "Pastel Spring",
    category: 'Advanced',
    colors: ["#fed9a6", "#decbe4", "#fbb4ae", "#b3cde3", "#ccebc5"],
  },
  3: {
    id: 3,
    name: "Earth Tones",
    category: 'Advanced',
    colors: ["#a6611a", "#dfc27d", "#f5f5f5", "#80cdc1", "#018571"],
  },
  4: {
    id: 4,
    name: "Ocean",
    category: 'Advanced',
    colors: ["#f7fcf0", "#ccebc5", "#7bccc4", "#2b8cbe", "#084081"],
  },
  5: {
    id: 5,
    name: "Inferno",
    category: 'Expert',
    colors: ["#000004", "#420a68", "#932667", "#dd513a", "#fca50a", "#fcffa4"],
  },
  6: {
    id: 6,
    name: "Viridis",
    category: 'Expert',
    colors: ["#440154", "#3b528b", "#21908d", "#5dc863", "#fde725"],
  },
  7: {
    id: 7,
    name: "Magma",
    category: 'Expert',
    colors: ["#400b0b", "#a12424", "#ee7b06", "#ffa904", "#ffdb00"],
  },
};

export const getColorGradient = (colorScheme: ColorScheme, colorSchemeReverse: boolean) => {
  return `linear-gradient(to ${colorSchemeReverse ? 'left' : 'right'},${colorScheme.colors.join(',')})`;
};
